import {memo, useCallback, useEffect, useMemo, useState} from "react";
import {MapContainer, Marker, ScaleControl, Tooltip, ZoomControl} from "react-leaflet";
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import {Icon} from "leaflet";
import FloorControl from "./controls/FloorControl";
import {ToggleControl} from "./controls/ToggleControl";
import ZoomListener from "./controls/ZoomListener";

const GoogleMapLoader = ({
                             isEliOfficeLocation,
                             isTestLocation,
                             isMYLocation,
                             updateLocations = true,
                             setUpdateLocations,
                             locationMarker = {}
                         }) => {
    const [mapLoading, setMapLoading] = useState(true);
    const [selectedFloor, setSelectedFloor] = useState(null);

    const GoogleMarkerIcon = (isLast) => new Icon({
        iconUrl: '/static/img/google-loc.png',
        iconSize: [54, 54],
        className: isLast ? "" : "grayscale-80"
    })
    const EmlMarkerIcon = (isLast) => new Icon({
        iconUrl: '/static/img/eml-marker.png',
        iconSize: [54, 54],
        className: isLast ? "" : "grayscale-80"
    })

    const floors = useMemo(() => isEliOfficeLocation ? [
        {name: "F1", url: "/static/img/1.pmtiles", value: "1"},
        {name: "F2", url: "/static/img/2.pmtiles", value: "2"},
        {name: "F3", url: "/static/img/3.pmtiles", value: "3"}
    ] : isTestLocation ? [
        {name: "F1", url: "/static/img/SBL.tif", value: "1"}
    ] : isMYLocation ? [
        {name: "F2", url: "/static/img/MY-F2.tif", value: "1"}
    ] : [], [isEliOfficeLocation, isTestLocation, isMYLocation]);

    useEffect(() => {
        if (isEliOfficeLocation) {
            setMapLoading(true);
            return;
        }
        setMapLoading(false);
    }, [isEliOfficeLocation, setMapLoading]);

    const setLoaded = useCallback((loaded) => setMapLoading(!loaded), [setMapLoading]);

    // console.log("locationMarker", locationMarker);
    const currentFloor = selectedFloor && !updateLocations
        ? {name: `F${selectedFloor}`, value: selectedFloor}
        : locationMarker?.floor
            ? {name: `F${locationMarker.floor}`, value: locationMarker.floor}
            : floors && floors.length ?
                {name: `F${floors[0].value}`, value: floors[0].value}
                : null;
    const displayMarker = locationMarker?.id && (locationMarker?.type === "gps" || locationMarker?.floor === currentFloor?.value);
    const mapLoaded = !mapLoading;
    return <>
        <div className="w-full h-[30px] bg-slate-200">
            {mapLoading && <div className='h-1.5 w-full bg-blue-100 overflow-hidden'>
                <div className='animate-progress w-full h-full bg-blue-300 origin-left-right'></div>
            </div>
            }
        </div>
        <MapContainer attributionControl={false}
                      center={EARTH_CENTER_LAT_LNG}
                      zoom={3}
                      scrollWheelZoom={true}
                      zoomControl={false}
        >
            <ReactLeafletGoogleLayer apiKey='AIzaSyADlCDm6O5btPvU5PzWPbBBJfsSataS6ds' type={'satellite'}/>
            <ScaleControl position="bottomright"/>
            <ZoomControl position="topright"/>
            <ToggleControl className="mt-14 ml-2"
                           position="topleft"
                           label="Auto refresh"
                           toggleState={updateLocations}
                           setToggleState={setUpdateLocations}/>
            <ZoomListener mapLoaded={mapLoaded}/>
            <FloorControl floors={floors}
                          setLoaded={setLoaded}
                          handleSelectFloor={setSelectedFloor}
                          currentFloor={currentFloor}/>
            {
                displayMarker && <Marker key={`e-${locationMarker.id}`}
                                         position={[locationMarker.lat, locationMarker.lng]}
                                         icon={locationMarker.type === "aps" ? EmlMarkerIcon(true) : GoogleMarkerIcon(true)}>
                    <Tooltip>{locationMarker.id}</Tooltip>
                </Marker>
            }
        </MapContainer>
    </>
};

export default memo(GoogleMapLoader);
const EARTH_CENTER_LAT_LNG = {lat: 54.331444157894936, lng: -108.15223571159713};
